import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useParams, useHistory } from "react-router-dom";
import Loader from "../../components/loader";
import api from "../../services/api";

const INFORMATION = "INFORMATION";
const RAW_DATA = "RAW_DATA";

export default () => {
  const [user, setUser] = useState();
  const [tab, setTab] = useState(INFORMATION);
  const { id } = useParams();

  useEffect(() => {
    (async () => {
      try {
        const res = await api.get(`/users/${id}`);
        if (!res.ok) return toast.error(res.error);
        setUser(res.data);
      } catch (e) {
        toast.error(e.message);
      }
    })();
  }, [id]);

  if (!user) return <Loader />;

  return (
    <div>
      <nav className="flex items-center gap-2 pl-2">
        <button
          className={`${
            tab === INFORMATION && "bg-black-80 text-white"
          } transition-colors px-3 py-2 text-sm`}
          onClick={() => setTab(INFORMATION)}
        >
          Information
        </button>
        <button
          className={`${
            tab === RAW_DATA && "bg-black-80 text-white"
          } transition-colors px-3 py-2 text-sm`}
          onClick={() => setTab(RAW_DATA)}
        >
          Raw Data
        </button>
      </nav>
      <div className="bg-white rounded-md p-6 border border-primary-black-50">
        {tab === INFORMATION && <Information user={user} />}
        {tab === RAW_DATA && <RawData user={user} />}
      </div>
    </div>
  );
};

const Information = ({ user }) => {
  const [values, setValues] = useState(user || {});
  const history = useHistory();

  const onUpdate = async () => {
    try {
      const res = await api.put(`/users/${user.id}`, values);
      if (!res.ok) return toast.error(res.error);
      toast.success("Updated!");
    } catch (error) {
      toast.error("Update failed!");
    }
  };

  const onDelete = async () => {
    if (!window.confirm("Are you sure?")) return;
    try {
      const res= await api.remove(`/users/${user.id}`);
      if (!res.ok) return toast.error(res.error);
      toast.success("Deleted!");
      history.push("/user");
    } catch (error) {
      toast.error("Delete failed!");
    }
  };

  return (
    <div>
      <div className="grid grid-cols-2 gap-4">
        <div className="w-full">
          <div className="text-sm font-medium mb-2">First Name</div>
          <input
            className="input"
            value={values.firstName || ""}
            onChange={(e) =>
              setValues({ ...values, firstName: e.target.value })
            }
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Last Name</div>
          <input
            className="input"
            value={values.lastName || ""}
            onChange={(e) => setValues({ ...values, lastName: e.target.value })}
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Phone</div>
          <input
            className="input"
            value={values.phone || ""}
            onChange={(e) => setValues({ ...values, phone: e.target.value })}
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Address</div>
          <input
            className="input"
            value={values.address || ""}
            onChange={(e) => setValues({ ...values, address: e.target.value })}
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Birthdate</div>
          <input
            className="input"
            type="date"
            value={values.birthdate ? values.birthdate.split("T")[0] : ""}
            onChange={(e) =>
              setValues({ ...values, birthdate: e.target.value })
            }
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Gender</div>
          <select
            className="input"
            value={values.gender || ""}
            onChange={(e) => setValues({ ...values, gender: e.target.value })}
          >
            <option value="f">Female</option>
            <option value="m">Male</option>
            <option value="o">Other</option>
          </select>
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Username</div>
          <input
            className="input"
            value={values.username || ""}
            onChange={(e) => setValues({ ...values, username: e.target.value })}
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Email</div>
          <input
            className="input"
            value={values.email || ""}
            onChange={(e) => setValues({ ...values, email: e.target.value })}
          />
        </div>
        <div className="w-full">
          <div className="text-sm font-medium mb-2">Code</div>
          <CodeSelector
            value={values.code || ""}
            onChange={(code) => setValues({ ...values, code: code })}
          />
        </div>
      </div>
      <div className="flex items-center space-x-2 mt-4">
        <button className="btn btn-primary" onClick={onUpdate}>
          Update
        </button>
        <button className="btn btn-red" onClick={onDelete}>
          Delete
        </button>
      </div>
    </div>
  );
};

const RawData = ({ user }) => {
  return (
    <div>
      <pre> {JSON.stringify(user, null, 2)}</pre>
    </div>
  );
};

const CodeSelector = ({ value, onChange }) => {
  const [codes, setCodes] = useState([]);

  useEffect(() => {
    getCodes();
  }, []);

  const getCodes = async () => {
    const res = await api.get("/codes");
    if (!res.ok) return toast.error(res.error);
    setCodes(res.data);
  };

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="input block"
    >
      <option value="">Select code</option>
      {codes.map((code) => (
        <option value={code.code} key={code.code}>
          {code.code}
        </option>
      ))}
    </select>
  );
};
